import { useEffect, useRef } from "react";
import { useToast } from "@swordsweeper/ssi-ui-component-library";

const DJANGO_TAG_TO_VARIANT: Record<string, "success" | "error"> = {
  success: "success",
  error: "error",
  warning: "error",
  info: "success",
};

/**
 * Reads Django messages injected into window.djangoConfig.DJANGO_MESSAGES
 * and displays them as toasts. Messages are consumed once on mount.
 */
export default function useDjangoMessages(): void {
  const { showToast } = useToast();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;

    const messages = window.djangoConfig?.DJANGO_MESSAGES;
    if (!messages || messages.length === 0) return;

    hasProcessed.current = true;

    messages.forEach((msg) => {
      const variant = Object.keys(DJANGO_TAG_TO_VARIANT).find((tag) =>
        msg.tags.includes(tag),
      );
      showToast({
        message: msg.text,
        variant: variant ? DJANGO_TAG_TO_VARIANT[variant] : "success",
      });
    });

    // Clear processed messages so they don't re-fire on navigation
    window.djangoConfig!.DJANGO_MESSAGES = [];
  }, [showToast]);
}
